import { Injectable } from '@angular/core';

import { ConfigurationService } from '../../services/configuration.service';

@Injectable()
export class VatService extends ConfigurationService {

    public modelPath = 'pharmacy/vats';

    getDTColumns () {
        const self = this;
        return [{
            name: 'vat_id',
            title: 'Vat Id',
            visible: false,
            orderable: false,
            searchable: false,
            data: 'vat_id'
        }, {
            name: 'vat',
            title: 'Vat (In %)',
            data: 'vat'
        }, {
            title: 'Status',
            orderable: false,
            searchable: false,
            render: function (data: any, type: any, full: any) {
                if (self.globalHelper.checkUserAccess('configuration/update-vat')) {
                    return `<div class="custom-control custom-checkbox">
						<input class="custom-control-input" data-modelPk="checkbox_${full.vat_id}" id="checkbox_${full.vat_id}" type="checkbox" />
						<label class="custom-control-label" for="checkbox_${full.vat_id}"></label>
					</div>`;
                }
                return `<label class="label label-${full.status === 1 ? 'success' : 'danger'}">
					${full.status === 1 ? 'Active' : 'Inactive'}
				</label>`;
            }
        }, {
            title: 'Action',
            orderable: false,
            searchable: false,
            render: function (data: any, type: any, full: any) {
                if (self.globalHelper.checkUserAccess('configuration/update-vat')) {
                    return `<a href="javascript:void(0)" data-modelPk="${full.vat_id}" class="btn btn-secondary">
						<i class="icon-pencil" data-modelPk="${full.vat_id}"></i>
					</a>`;
                }
                return '';
            }
        }];
    }
}
